module.exports = __webpack_public_path__ + "img/pr-20.f89d62f9.png";